module.exports = __webpack_public_path__ + "img/MapPicsGreatLake.45c72d8e.webp";